export default "__VITE_ASSET__bd0ca1b3__"